import { Button, ButtonProps } from "@mui/material";
import { COLORS } from "components/consts";
import React from "react";

interface BasicButtonProps extends ButtonProps {
    onClick?: () => void;
    children: React.ReactNode;
    disabled?: boolean;
}

export const BasicButton: React.FC<BasicButtonProps> = ({ onClick, children, sx, disabled, ...props }) => (
    <Button
        sx={{
            height: "36px",
            mr: 2,
            paddingTop: "8px",
            marginTop: "22px",
            borderRadius: "7px",
            border: "1px solid",
            color: props.variant === "contained" ? "white" : COLORS.Romance,
            borderColor: disabled ? COLORS.muiDisabled : COLORS.Romance,
            ...sx,
        }}
        onClick={onClick}
        disabled={disabled}
        {...props}
    >
        {children}
    </Button>
);
